import { AskRequest } from '@hone-automation/common';
import { formatTransactionDetails } from '../../../../hooks/utils/transactionDetailsFormatter';
import type { MessageDetailsContent } from '../../KSQ2/Cards/MessagesCard/subcomponents/MessageContent/analyzeMessageContent';

/**
 * Converts an AskRequest into MessageDetailsContent for display in the DetailsPreview component
 */
export const formatAskRequestDetails = (
  request: AskRequest | null | undefined,
  sectionAmount?: number
): MessageDetailsContent | undefined => {
  if (!request) {
    return undefined;
  }

  const details = formatTransactionDetails(request);
  if (!details) {
    return undefined;
  }

  const {
    isAskRequest,
    isFlaggedTransaction,
    isFlaggedCell,
    isCustomRequest,
    createdDate,
    trxDate,
    createdByUser,
    transactionName,
    transactionMemo,
    transactionAccount,
    transactionType,
    transactionAmount,
    flaggedAmount,
    hasBlockerPriority,
  } = details;

  // Build sections based on request type
  const sections: MessageDetailsContent['sections'] = [];

  // Build rows matching InfoPanel exactly
  const requestInfoRows = [];

  if (isCustomRequest) {
    // Custom Request view - matches InfoPanel lines 75-81
    requestInfoRows.push({ label: 'Created on', value: createdDate }, { label: 'Created by', value: createdByUser });
    if (hasBlockerPriority) {
      requestInfoRows.push({ label: 'Priority', value: 'Urgent', highlight: true });
    }

    sections.push({
      rows: requestInfoRows,
    });
  } else if (isFlaggedCell) {
    // Flagged Cell view - matches InfoPanel lines 85-92
    // Logic for Current Amount and Original Amount:
    // - If sectionAmount exists and differs from flaggedAmount:

    const hasSectionAmount = sectionAmount !== undefined && sectionAmount !== null;
    const flaggedAmountNum = typeof flaggedAmount === 'string' ? parseFloat(flaggedAmount) : flaggedAmount;
    const amountsAreDifferent = hasSectionAmount && sectionAmount !== flaggedAmountNum;

    const currentAmount = amountsAreDifferent ? sectionAmount : flaggedAmountNum || transactionAmount;
    const originalAmount = amountsAreDifferent ? flaggedAmountNum : undefined;

    requestInfoRows.push(
      /* { label: 'Created on', value: createdDate },
      { label: 'Created by', value: createdByUser }, */
      { label: 'Amount', value: currentAmount, money: true, originalMoney: originalAmount }
    );
    if (hasBlockerPriority) {
      requestInfoRows.push({ label: 'Priority', value: 'Urgent', highlight: true });
    }

    sections.push({
      rows: requestInfoRows,
    });
  } else if (isFlaggedTransaction || isAskRequest) {
    // Transaction Request view - matches InfoPanel lines 96-108
    requestInfoRows.push(
      { label: 'Trx Type', value: transactionType },
      { label: 'Account', value: transactionAccount },
      /*     { label: 'Created on', value: createdDate },
      { label: 'Created by', value: createdByUser }, */
      { label: 'Trx Date', value: trxDate },
      { label: 'Vendor', value: transactionName },
      { label: 'Description', value: transactionMemo },
      { label: 'Amount', value: flaggedAmount || transactionAmount, money: true }
    );
    if (hasBlockerPriority) {
      requestInfoRows.push({ label: 'Priority', value: 'Urgent', highlight: true });
    }

    sections.push({
      rows: requestInfoRows,
    });
  }

  return {
    title: 'Request Details',
    requestType: request.type as MessageDetailsContent['requestType'],
    sections,
  };
};
